module.exports = __webpack_public_path__ + "assets/img/cons-minus-icon.58e6d516.svg";